import React, { useState } from "react";
import { Segment } from "semantic-ui-react";

import DashboardOptions from "./DashboardOptions";
import DashboardTable from "./DashboardTable";

function Dashboard({ userInfo }) {
  const [files, setFiles] = useState([]);

  const table = files.length ? (
    <DashboardTable files={files} />
  ) : (
    <>
      <div style={{ height: "400px" }}></div>
    </>
  );

  return (
    <Segment vertical>
      <DashboardOptions userInfo={userInfo} setFiles={setFiles} />
      {table}
    </Segment>
  );
}

export default Dashboard;
